import React, { useState, useEffect } from 'react'; 
import { useStateContext } from '../../contexts/ContextProvider';
import { FooterPages } from '..';
import { MdOutlineCancel } from 'react-icons/md';
import { getClientes } from "../../services/Clientes";
import { crearTicket } from '../../services/Tikets';
import {formatDate} from '../../formatters/date';
import { fetchUser } from '../../utils/fetchUser';
import { getMensajeRol } from '../../services/UsuarioSucursal';
import { crearMensaje, notificarUsuario } from '../../services/Util';
import { useImplementaMutations } from '../../hooks/implementa/useImplementaMutations';
import { Toaster,toast } from 'react-hot-toast';
import { IoSend } from "react-icons/io5";
import { MdAssignmentTurnedIn } from "react-icons/md"; // Puedes elegir otro icono si prefieres
import SearchMaquinas from '../Search/SearchMaquinas';
import { updateImplementaSelect, updateImplementaAnular } from '../../services/Implementa';
import { updateAsignacionDatos } from '../../services/Asignaciones';
import { is } from 'date-fns/locale';

const initialState = {
  empresa: null,
  solicitudEmin: false,
  solicitudGPS: false,
  logosEmin: false,
  adicionalEmin: false,
  certificaEmin: false,
  inspeccionEmin: false, 
  funcionalEmin: false, 
  idTicket: null,
  numTicket: '', 
  fechaEntrega: '',
  estadoTicket: 'Pendiente',  
  idTicketCal: null,
  numTicketCal: '', 
  fechaEntregaCal: '',  
  estadoTicketCal: 'Pendiente',
  numOTCal: '',
  mandante: '',
  proyecto: '',
  nombreProveedor: '',
  ubicacionEquipo: '',
  linequipo: '',
  serie:'',
  patente:'',
  anno:'',
  origen:'',
  numeroInterno:'',
  codigoEquipo: '',
  ubicacion: '',
  otFracttal: '',
  fecha: '',
  estado: 'Pendiente',
  comentarios: []
};

const Implementa = ({ vecinoData, onChangeVecino }) => {
  const { isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [clientesData, setClientesData] = useState([]);
  const { updateImplementaC } = useImplementaMutations();
  const [equipoData, setEquipoData] = useState([]);
  const [newComment, setNewComment] = useState("");
  const userInfo = fetchUser();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";
  const [isFinalizado, setIsFinalizado] = useState(true);



  useEffect(() => {
     

    if (vecinoData) {

     const miEquipoImplementar = vecinoData.detalleAsignados.find((item) => item.lin === vecinoData.lin);

     if (vecinoData.estado === "Finalizado") {  setIsFinalizado(true); } else { setIsFinalizado(false); }
    //  console.log("miEquipoImplementar", miEquipoImplementar);

console.log(" ENTRE A ESTE PROGRAMA DATOS ", vecinoData.estado  + " - " + isFinalizado);

     // const misComentarios = vecinoData.comentarios.map(comentarioObj => comentarioObj.comentario);
        setFormData({
            ...vecinoData, nombreProveedor: miEquipoImplementar.nombreProveedor,
            estado: vecinoData.estado ,
            anno: vecinoData.anno,
            otFracttal: vecinoData.numOT,
            numOTCal: vecinoData.numOTCal,
            patente: vecinoData.patente,
            serie: vecinoData.serie,
            origen: miEquipoImplementar.origen,
            solicitudEmin: vecinoData.solicitudEmin || false,
            solicitudGPS: vecinoData.solicitudGPS || false,
            logosEmin: vecinoData.logosEmin || false,
            adicionalEmin: vecinoData.adicionalEmin || false,
            certificaEmin: vecinoData.certificaEmin || false,
            inspeccionEmin: vecinoData.inspeccionEmin || false, 
            funcionalEmin: vecinoData.funcionalEmin || false, 
            linequipo: miEquipoImplementar.linequipo,
            codigoEquipo: vecinoData.numeroInterno + ' - ' + miEquipoImplementar.marca + ' - ' + miEquipoImplementar.modelo || "",
            numeroInterno: vecinoData.numeroInterno,
            comentarios: vecinoData.comentarios ? vecinoData.comentarios : []
          });
          
    }
  }, [vecinoData]);

  useEffect(() => {
    const fetchData = async () => {
      const misClientes = await getClientes();
      setClientesData(misClientes);
    };
    fetchData();
  }, []);

// RETORNO DEL VALOR SELECCIONADO DE LA BUSQUEDA
const handleValorSeleccionadoChange = (equipoS) => {

  if (equipoS !== '')
  {
    setFormData({
      ...vecinoData,
      patente: equipoS.patente,
      serie: equipoS.serie,
      codigoEquipo: equipoS.nombreEquipo || "",
      numeroInterno: equipoS.codigo,
      anno: equipoS.anno,
      origen: equipoS.origen
    });

  }
};

/*
  const handleFileChange = async (index, e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;
  
        const response = await uploadFile(selectedFile);
        if (response && response.fileId) {

          setDocumentos((prevDocs) => {
            const updatedDocs = [...prevDocs];
        
            // Verificar si el índice existe en el array, si no, crear un objeto vacío
            if (!updatedDocs[index]) {
              updatedDocs[index] = {};
            }
        
            // archivo: selectedFile,

            updatedDocs[index] = {
              ...updatedDocs[index], // Mantiene los valores anteriores del objeto
              nombreArchivo: selectedFile.name,
              urlArchivo: URL.createObjectURL(selectedFile),
              idArchivo: response.fileId
            };
        
         //   console.log("Archivo actualizado en documentos:", updatedDocs[index]);
        
            return updatedDocs;
          });

        } else {
          toast.error('Error al subir el archivo.');
          console.error('Error de carga:');
        }
  };
  */

 /* const handleDateChange = (index, date) => {
    const updatedDocumentos = [...formData.documentos];
    updatedDocumentos[index].fechaVigencia = date;
    setFormData({ ...formData, documentos: updatedDocumentos });
  };
*/

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  //       _id: crypto.randomUUID(), // puedes cambiar esto por un uuid si prefieres
const handleCommentSubmit = () => {
  if (newComment.trim()) {
    const nuevoComentario = {
      comentario: newComment
    };

    setFormData({
      ...formData,
      comentarios: [...(formData.comentarios || []), nuevoComentario]
    });

    setNewComment("");
  }
};


const handleTicket = async () => {

    if (formData.numTicket !== "") {
      toast.error('El ticket ya esta en proceso.');
      return;
    }
  try {

    const dataBase = {
      empresa: userInfo.empresa,
      tipo: 'Taller',
      numTicket: 0, // Número secuencial
      requerimiento: 'Solicitud de Implementación ' + formData.numeroInterno,
      observacion: 'Se solicita realizar la implementación a la brevedad de Radio y GPS ' + formData.numeroInterno,
      documentosRespaldo: [],
      fechaEntrega: null,
      numOT:'',
      fechaCreacion: new Date().toISOString(),
      idCreador: userInfo.usuario,
      idAsignado: null,
      estado: 'Pendiente',
    };

    const miTicket = await crearTicket( dataBase );

    setFormData({...formData, idTicket: miTicket._id, numTicket: miTicket.numTicket});

    const dataUP = {_id: vecinoData._id,
      idTicket: miTicket._id , 
      fechaImpleGPS: "", 
      estadoTicket: "Pendiente", 
      idTicketCal: "", 
      fechaCalidad: "", 
      estadoTicketCal: "",
      numOT: "",
      numOTCal: "",
      serie: formData.serie , 
      patente: formData.patente, 
      anno: formData.anno,
      numeroInterno: formData.numeroInterno
    };
    const updtesInfo = await updateImplementaSelect(dataUP);

    const updateData = {
      _id: vecinoData.idasignaciones,
      idCarpeta: vecinoData.idCarpeta,
      lineaAsig: formData.lin,
      serie: formData.serie , 
      patente: formData.patente, 
      anno: formData.anno,
      numeroInterno: formData.numeroInterno

    };
    const upDataAsig = await updateAsignacionDatos(updateData);

    const mUser = await getMensajeRol('Taller');
    const dataMensaje = {
    numeroInterno: formData.numeroInterno,
    serie: formData.serie , 
    patente: formData.patente, 
    codigo: vecinoData.codigo,
    nombreProyecto: vecinoData.nombreProyecto,
    ubicacion: vecinoData.ubicacion
   };
    if (mUser){
      mUser.forEach(element => {     
        let mensaje = crearMensaje(element._id, 'nuevoTicket', dataMensaje);
        notificarUsuario(JSON.stringify(mensaje));
      });
    }

  } catch (error) {
    toast.error('Problemas al generar ticket de Implementación.');
  }

};

const handleTicketCalidad = async () => {
  if (formData.numTicketCal !== "") { 
    toast.error('El ticket ya esta en proceso.');
    return;
  }
  // AQUI SE inserta el ticket
  try {

    const dataBase = {
      empresa: userInfo.empresa,
      tipo: 'Calidad',
      numTicket: 0, // Número secuencial
      requerimiento: 'Solicitud de Revisión de Calidad - ' + formData.numeroInterno ,
      observacion: 'Se solicita realizar a la brevedad la revisión de Calidad del equipamiento ' + formData.numeroInterno,
      documentosRespaldo: [],
      fechaEntrega: null,
      numOT:'',
      fechaCreacion: new Date().toISOString(),
      idCreador: userInfo.usuario,
      idAsignado: null,
      estado: 'Pendiente',
    };

    // console.log('crear VECINO');
    const miTicket = await crearTicket( dataBase );

    setFormData({ ...formData, idTicketCal: miTicket._id, numTicketCal: miTicket.numTicket });

    const dataUP = {_id: vecinoData._id,
      idTicket: "" , 
      fechaImpleGPS: "", 
      estadoTicket: "", 
      idTicketCal: miTicket._id, 
      fechaCalidad: "", 
      estadoTicketCal: "Pendiente",
      numOT: "",
      numOTCal: "",
      serie: formData.serie , 
      patente: formData.patente, 
      anno: formData.anno,
      numeroInterno: formData.numeroInterno
    };
    const updtesInfo = await updateImplementaSelect(dataUP)

    const updateData = {
      _id: vecinoData.idasignaciones,
      idCarpeta: vecinoData.idCarpeta,
      lineaAsig: formData.lin,
      serie: formData.serie , 
      patente: formData.patente, 
      anno: formData.anno,
      numeroInterno: formData.numeroInterno

    };
    const upDataAsig = await updateAsignacionDatos(updateData);

    const rolDestino = formData.origen !== 'PROPIO' ? 'Supervisor de Logística' : 'Calidad';
    const mUser = await getMensajeRol(rolDestino);
    const dataMensaje = {
    numeroInterno: formData.numeroInterno,
    serie: formData.serie ,
    patente: formData.patente,
    codigo: vecinoData.codigo,
    nombreProyecto: vecinoData.nombreProyecto,
    ubicacion: vecinoData.ubicacion
   };
    if (mUser){
      mUser.forEach(element => {
        let mensaje = crearMensaje(element._id, 'nuevoTicket', dataMensaje);
        notificarUsuario(JSON.stringify(mensaje));
      });
    }


  } catch (error) {
    toast.error('Problemas al generar ticket de Calidad.');
  }

};


const handleAnular = () => {
  let comentario = "";
  toast.custom((t) => (
    <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-full">
      <h3 className="text-lg font-semibold">¿Está seguro de anular?</h3>
      <textarea
        className="w-full h-24 p-2 mt-2 border rounded-md"
        placeholder="Ingrese su comentario..."
        onChange={(e) => (comentario = e.target.value)}
      />
      <div className="flex justify-end gap-2 mt-4">
        <button
          type="button"
          className="px-4 py-2 bg-gray-400 text-white rounded"
          onClick={() => toast.dismiss(t.id)}
        >
          Cancelar
        </button>
        <button
          type="button"
          className="px-4 py-2 bg-red-500 text-white rounded"
          onClick={async () => {
              try {
                await updateImplementaAnular(vecinoData._id, {
                  idUsuario: userInfo.usuario,
                  comentario: comentario
                });

                toast.success("Implementación rechazada correctamente");
              } catch (error) {
                console.error(error);
                toast.error("Error al rechazar implementación");
              }

              toast.dismiss(t.id);
          }}
        >
          Confirmar
        </button>
      </div>
    </div>
  ));
};

const handleCerrar = () => {

  onChangeVecino('REFRESH');
  setIsClicked(!isClicked.nuevoImplementa);
};

const handleSubmitD = () => {

};

const handleSubmit = async () => {

  if (formData.estadoTicketCal === 'Pendiente' || formData.estadoTicket === 'Pendiente') {
    toast.error('Debe finalizar el ticket de calidad o implementacion.');
    return;
  }
  if (formData.numeroInterno === '' || formData.numeroInterno === null ) {
    toast.error('El número interno debe ser ingresado.');
    return;
  }
  if (formData.patente === '' || formData.patente === null ) {
    toast.error('Debe ingresar la patente de la maquina.');
    return;
  }
  if (formData.serie === '' || formData.serie === null) {
    toast.error('Debe ingresar la serie de la maquina.');
    return;
  }
  if (formData.anno === '' || formData.anno === null) {
    toast.error('Debe ingresar la serie de la maquina.');
    return;
  }

  try {

    console.log("FINALIZAR");

    const formDataToSend = {
      _id: vecinoData._id,
      empresa: userInfo.empresa,
      idasignaciones: vecinoData.idasignaciones,
      lin: vecinoData.lin,
      idTicket: formData.idTicket,
      estadoTicket: formData.estadoTicket,
      numOT: formData.otFracttal,
      solicitudEmin: formData.solicitudEmin,
      solicitudGPS: formData.solicitudGPS,
      logosEmin: formData.logosEmin  ,
      adicionalEmin: formData.adicionalEmin ,
      certificaEmin: formData.certificaEmin ,
      inspeccionEmin: formData.inspeccionEmin ,
      funcionalEmin: formData.funcionalEmin,
      comentarios: formData.comentarios ,
      anno: formData.anno,
      patente: formData.patente,
      serie:  formData.serie,
      NumeroInterno: formData.numeroInterno,
      fechaImpleGPS: formData.fechaEntrega,
      idTicketCal: formData.idTicketCal,
      estadoTicketCal: formData.estadoTicketCal,
      fechaCalidad: formData.fechaEntregaCal,
      numOTCal: formData.numOTCal,
      fechaCreacion:'',
      estado: 'Finalizado'
      };
      console.log("FINALIZAR formDataToSend IMPLEMENTA ", formDataToSend);

      await updateImplementaC.mutateAsync(formDataToSend);

    const updateData = {
      _id: vecinoData.idasignaciones,
      idCarpeta: vecinoData.idCarpeta,
      lineaAsig: formData.lin,
      serie: formData.serie , 
      patente: formData.patente, 
      anno: formData.anno,
      numeroInterno: formData.numeroInterno

    };
    const upDataAsig = await updateAsignacionDatos(updateData);

      onChangeVecino('REFRESH');
      setIsClicked(!isClicked.nuevoImplementa);

    } catch (error) {
      console.error('Error al guardar:', error);
      toast.error('Error al guardar los datos.');
    }
  };

  const handleGuardar = async () => {
    try {
      const formDataToSend = {
        _id: vecinoData._id,
      empresa: userInfo.empresa,
      idasignaciones: vecinoData.idasignaciones,
      lin: vecinoData.lin,
      idTicket: formData.idTicket,
      estadoTicket: formData.estadoTicket,
      numOT: formData.otFracttal,
      solicitudEmin: formData.solicitudEmin,
      solicitudGPS: formData.solicitudGPS,
      logosEmin: formData.logosEmin  ,
      adicionalEmin: formData.adicionalEmin ,
      certificaEmin: formData.certificaEmin ,
      inspeccionEmin: formData.inspeccionEmin ,
      funcionalEmin: formData.funcionalEmin,
      comentarios: formData.comentarios ,
      anno: formData.anno,
      patente: formData.patente,
      serie:  formData.serie,
      NumeroInterno: formData.numeroInterno,
      fechaImpleGPS: formData.fechaEntrega,
      idTicketCal: formData.idTicketCal,
      estadoTicketCal:formData.estadoTicketCal,
      fechaCalidad: formData.fechaEntregaCal,
      numOTCal: formData.numOTCal,
      fechaCreacion:'',
      estado: 'Pendiente'
      };
      console.log("GUARDAR formDataToSend IMPLEMENTA ", formDataToSend);
      await updateImplementaC.mutateAsync(formDataToSend);

    const updateData = {
      _id: vecinoData.idasignaciones,
      idCarpeta: vecinoData.idCarpeta,
      lineaAsig: formData.lin,
      serie: formData.serie ,
      patente: formData.patente,
      anno: formData.anno,
      numeroInterno: formData.numeroInterno

    };
    const upDataAsig = await updateAsignacionDatos(updateData);

      toast.success('Cambios guardados.');
      
    } catch (error) {
      console.error('Error al guardar:', error);
      toast.error('Error al guardar los datos.');
    }
  };


  return (
    <form onSubmit={handleSubmitD}>
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
     <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-full p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
              Implementación
              </p>
            </div>

            <button
              type="button"
              onClick={() => { onChangeVecino('REFRESH'); setIsClicked(!isClicked.nuevoImplementa)}}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>

          <div className="mt-5 space-y-4">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-2 md:grid-cols-8 gap-4" >
                  <div className="col-span-2">
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Proyecto</label>
                        <input
                            type="text"
                            className={inputClass}
                            placeholder=""
                            name="nombreProyecto"
                            value= {vecinoData.nombreProyecto}
                            disabled
                            onChange={handleChange}
                        />
                    </div>
                  </div>
                  <div className="col-span-2">
                      <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Ubicación</label>
                          <input
                              type="text"
                              className={inputClass}
                              placeholder=""
                              name="ubicacion"
                              value= {vecinoData.ubicacion}
                              disabled
                              onChange={handleChange}
                          />
                      </div>
                    </div>

                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Fecha en Obra</label>
                      <input
                          type="text"
                          className={inputClass}
                          placeholder=""
                          name="fechaEnObra"
                          value= {vecinoData.fechaEnObra ? formatDate(vecinoData.fechaEnObra) : '-'}
                          disabled
                          onChange={handleChange}
                      />
                    </div>
                    <div className="col-span-2">
                      <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Proveedor</label>
                        <input
                          type="text"
                          className={inputClass}
                          placeholder=""
                          name="nombreProveedor"
                          value= {formData.nombreProveedor}
                          disabled
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Estado</label>
                      <select className={inputClass} name="estado" value= {formData.estado} disabled onChange={handleChange}>
                          <option value="Pendiente">Pendiente</option>
                          <option value="Finalizado">Finalizado</option>
                          <option value="Eliminado">Eliminado</option>
                      </select>
                    </div>        
                </div>
              <div className="grid grid-cols-1 md:grid-cols-8 gap-4 mt-4" >
                <div className="flex flex-col mt-5">
                  <SearchMaquinas dataI={equipoData} onValorSeleccionadoChange={handleValorSeleccionadoChange}/>
                  {/* formData.origen === "PROPIO" ? (
                    <SearchMaquinas dataI={equipoData} onValorSeleccionadoChange={handleValorSeleccionadoChange}/>
                  ): <div className="flex flex-col"></div> */}
                    </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Número Interno</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="numeroInterno"
                    value= {formData.numeroInterno}
                    disabled
                    onChange={handleChange}
                  />
                </div> 
                <div className="col-span-3">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Equipo</label>
                    <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="codigoEquipo"
                        value= {formData.codigoEquipo}
                        disabled
                        onChange={handleChange}
                    />
                  </div>
                </div>
                {/* 
                <div className="col-span-2">
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Ubicación Equipo</label>
                    <input
                      type="text"
                      className={inputClass}
                      placeholder=""
                      name="ubicacionEquipo"
                      value= {formData.ubicacionEquipo}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              */}
                <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Serie</label>
                <input
                  type="text"
                  className={inputClass}
                  placeholder=""
                  name="serie"
                  disabled
                  value= {formData.serie}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Patente</label>
                <input
                  type="text"
                  className={inputClass}
                  placeholder=""
                  name="patente"
                  disabled
                  value= {formData.patente}
                  onChange={handleChange}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Año</label>
                <input
                  type="text"
                  className={inputClass}
                  placeholder=""
                  name="anno"
                  disabled
                  value= {formData.anno}
                  onChange={handleChange}
                />
              </div>      
      
            </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" >
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col">
                      <label className="flex items-center">
                          <input type="checkbox" name="solicitudEmin" checked={formData.solicitudEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Implementar Radio</label>
                      </label>
                      <label className="flex items-center">
                          <input type="checkbox" name="solicitudGPS" checked={formData.solicitudGPS} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Implementar GPS</label>
                      </label>
                      <label className="flex items-center">
                          <input type="checkbox" name="logosEmin" checked={formData.logosEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Confección e Instalación de Logos</label>
                      </label>
                      <label className="flex items-center">
                          <input type="checkbox" name="adicionalEmin" checked={formData.adicionalEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Implementación Adicional</label>
                      </label>
                      <label className="flex items-center">
                          <input type="checkbox" name="certificaEmin" checked={formData.certificaEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Certificación Adicional</label>
                      </label>
                      <label className="flex items-center">
                          <input type="checkbox" name="funcionalEmin" checked={formData.funcionalEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Funcionalidad de dispositivos</label>
                      </label>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2" >
                <div className="flex flex-col">
                </div>
                    <div className="flex flex-col">
                    <button
                      type="button"
                      onClick={handleTicket}
                      className="ml-2 px-2.5 py-1.5 flex items-center gap-1 text-xs bg-blue-500 text-white rounded-md hover:bg-blue-600 shadow-sm hover:shadow-md transition-all duration-200"
                    >   
                      <IoSend className="text-sm" />
                      Ticket
                    </button> 
                    </div>    
                </div>
                </div>   
             </div>  
             <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1" >Solicitud Implementación Radio/GPS</label>
                      </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-2 " >
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">N° Ticket</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="numTicket"
                        value= {formData.numTicket}
                        disabled
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Fecha Entrega</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="fechaEntrega"
                        value= {formData.fechaEntrega ? formatDate(formData.fechaEntrega) : ""}
                        disabled
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Estado</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="estadoTicket"
                        value= {formData.estadoTicket}
                        disabled
                        onChange={handleChange}
                      />
                    </div>
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">OT Fracttal</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="otFracttal"
                        value= {formData.otFracttal}
                        onChange={handleChange}
                      />
                  </div>
                </div>
            </div>
            </div>
          </div>


          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-4">
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" >

                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                  <div className="flex flex-col">
                      <label className="flex items-center">
                          <input type="checkbox" name="inspeccionEmin" checked={formData.inspeccionEmin} onChange={handleChange} className={inputClass} />
                          <label className="text-xs font-semibold mb-1" >Inspección de Calidad</label>
                      </label>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2" >
                <div className="flex flex-col">
                </div>
                  <div className="flex flex-col">
                    <button
                      type="button"
                      onClick={handleTicketCalidad}
                      className="ml-2 px-3 py-1.5 flex items-center gap-1 text-xs bg-green-600 text-white rounded-md hover:bg-green-700 shadow-sm hover:shadow-md transition-all duration-200"
                    >
                      <MdAssignmentTurnedIn className="text-sm" />
                      Calidad
                    </button>                  
                  </div>   
                </div>
            </div>
            </div>
            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1" >Solicitud Inspección de Calidad</label>
                      </div>
                </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4" >               
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">N° Ticket</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="numTicketCal"
                    value= {formData.numTicketCal}
                    disabled
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Fecha Entrega</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="fechaEntregaCal"
                    value= {formData.fechaEntregaCal ? formatDate(formData.fechaEntregaCal) : ""}
                    disabled
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="estadoTicketCal"
                    value= {formData.estadoTicketCal}
                    disabled
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">OT Fracttal</label>
                  <input
                    type="text"
                    className={inputClass}
                    placeholder=""
                    name="numOTCal"
                    value= {formData.numOTCal}
                    disabled
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>              
          </div>



            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg mt-2">
                    <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >

                        <div className="flex flex-col">

                            <label className="block text-xs font-medium">Comentarios</label>
                            <div className="border rounded-lg p-2 h-32 overflow-y-auto bg-gray-100">
                                {formData.comentarios && formData.comentarios.map((comentario, index) => (
                                <div key={index} className={`p-2 my-1 rounded-lg ${index % 2 === 0 ? 'bg-blue-200' : 'bg-gray-300'}`}>
                                    {comentario.comentario}
                                </div>
                                ))}
                            </div>
                            <div className="mt-2 flex">
                                <input
                                type="text"
                                className="w-full border px-3 py-2 rounded-lg"
                                placeholder="Escribe un comentario..."
                                value={newComment}
                                onChange={(e) => setNewComment(e.target.value)}
                                />
                                <button type="button" onClick={handleCommentSubmit} 
                                disabled= {formData.estado === 'Finalizado' ? true : false}
                                className={"px-4 py-2 " + (formData.estado === 'Finalizado' ? " bg-gray-300 ":" bg-blue-500 " ) + " text-white rounded-lg" + (formData.estado === 'Finalizado' ? " hover:bg-gray-400 ":" hover:bg-blue-600 " ) }
                                >Añadir</button>
                            </div>

                        </div>
                    </div>
            </div>

              <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-2">
                <div className="flex justify-end gap-2">
                    <button onClick={handleCerrar} className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400">Cerrar</button>
                    <button type="button" onClick={handleAnular} className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">Anular</button>
                    <button type="button" 
                    onClick={handleGuardar}
                    disabled= {formData.estado === 'Finalizado' ? true : false}
                    className={"px-4 py-2 " + (formData.estado === 'Finalizado' ? " bg-gray-300 ":" bg-blue-500 " ) + " text-white rounded-lg" + (formData.estado === 'Finalizado' ? " hover:bg-gray-400 ":" hover:bg-blue-600 " ) }
                    >
                      Guardar</button>
                    <button type="button" onClick={handleSubmit} 
                    disabled= {formData.estado === 'Finalizado' ? true : false}
                    className={"px-4 py-2 " + (formData.estado === 'Finalizado' ? " bg-gray-300 ":" bg-blue-500 " ) + " text-white rounded-lg" + (formData.estado === 'Finalizado' ? " hover:bg-gray-400 ":" hover:bg-blue-600 " ) }
                    >Finalizar</button>
                </div> 
              </div>           
              <FooterPages />  
              <Toaster
                position="top-right"
                toastOptions={{
                  style: {
                    zIndex: 9999,
                  },
                }}
              />   
          </div>

      </div>

    </form>
  );
};

export default Implementa;